<template>
    <div class="result-detail">
		<div class="contents">
			<h3 class="mark">
				<div class="type">
					<span>
						<img src="../assets/result-detail-communcation-icon01.svg" alt="*" />あなたのコミュニケーション
					</span>
				</div><!-- end .type -->
				<div class="cover">
					積極型{{communicateResult.percentageLeft}}%、独立型{{communicateResult.percentageRight}}%
				</div><!-- end .cover -->
			</h3><!-- end .mark -->
			<div class="sentence">
				<div class="catch">
					<span class="left">
						Detailed
					</span>
					<span class="right">
						explanation
					</span>
				</div><!-- end .catch -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>孤高を好み、対人関係にムラがあるが、その分、強い個性を持っている</h2>
				<img src="../assets/result-detail-communication-inright01.svg" alt="*" class="visual" />
				<div class="caption">
					もっと他人のために、自分の内向度を活用すると、より多様な世界へあなたは羽ばたける
				</div><!-- end .caption -->
				<p>3番目はコミュニケーションの特性を分析しました。自分のコミュニケーションの能力や癖は、内向的(もしくは外向的)気質を掛け合わさり、恋愛からビジネスまで、幅広い社会活動の結果に影響を与えるからです。</p>
				<p>単純に言えば、内向的な人が好かれるコミュニケーションと、外向的な人が好かれるコミュニケーションはまったく違います。あなたが内向的な人にも関わらず、外向的な人のコミュニケーションをお手本にしていると、自分の個性を伸ばせずに、苦しむことになるでしょう。</p>
				<p>あなたのコミュニケーション独立型{{communicateResult.percentageRight}}%という結果は、とても異質な結果と言えるでしょう。内向型でかつ、コミュニケーションが独立型のタイプは、対人関係にかなりムラがあるタイプと言えます。すごく好かれるケースと、うまくいかないケースの差が激しいのが、このタイプの特徴です。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>プレゼンテーションなどの独壇場でこそ、あなたの才能は開花される</h2>
				<img src="../assets/result-detail-communication-inright02.svg" alt="*" class="visual" />
				<div class="caption">
					自己主張を託された環境で、あなたは高いコミュニケーション能力を発揮する
				</div><!-- end .caption -->
				<p>現状のあなたの性質から言えることは、あなたは完全に自分が主体だと決まりきった環境で喋ることに向いているということです。</p>
				<p>例えば、あなた1人で行うプレゼンテーションを想像してみて下さい。聞き手は、あなたが話し始めてから終わるまで、あなたの話を聞きれる体制が出来上がっています。</p>
				<p>様々な情報を多感に受け取り、自分一人で掘り下げたり、あれこれと議論したり、そういった時間を、他のタイプよりも積み重ねていきます。すると、あなたは「一人で、何かを深く的確に語ること」が自然に長けていくわけです。</p>
				<p>しかし、あなたは大勢の人とフラットな立場で話すことが苦手な傾向にあります。人数が増えれば増えるほど、あなたが気にする刺激が増えるからです。大人数の会話では、一人当たりに与えられる時間が少なく、あなたのようなタイプは、「浅い話しかできなくて、つまらない」と感じがちです。</p>
				<p>パーティーや交流会、コミュニティ内の関係構築などでは、全員からの賞賛や承認を求めずに、相手を絞ってその相手と深く長い時間を過ごしていくことで、あなたの出会いの縁は良い方向に好転していくでしょう。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>信頼や信用の高さが、自分のコミュニケーションの結果を大きく変える</h2>
				<img src="../assets/result-detail-communication-inright03.svg" alt="*" class="visual" />
				<div class="caption">
					他者とは違う強みを自分自身で強く感じることが、あなたが活躍できる舞台をどこまでも広げていく
				</div><!-- end .caption -->
				<p>あなたは、自分一人で熱く語るような状況でこそ、魅力的になれる性質があります。もっと雑に言えば、あなたは「自分が上から目線で話せる環境」を最も得意とします。</p>
				<p>例えば、セミナー講師、講演家、コンサルタントなどの職業で大きく活躍する傾向がありますが、こういった職業は、何かを成し遂げた人、何か特別な専門やスキルを持ち合わせた人がありつける仕事です。
				<p>内向性が高く、コミュニケーションが独立的なあなたは、初対面の人にでもアピールできる分かりやすい長所や実績を持っていることが、人生の大きな鍵となるでしょう。相手があなたを受け入れている状態であれば、あなたの独壇場も受け入れられるからです。あなた自身も、「自分が他者とは違う魅力を持っている」という強い感覚がある場面では、楽な気持ちで大胆に会話をすることができるようになります。</p>
				<p>専門家が、専門的な立場から話す、こういった専門家は、専門的なスキルや実績があるからこそ、相手は黙って聞くことを気持ちよく受け入れるわけです。</p>
				<p>あなたの独立的な性質とは、多くの人との会話を経験することで解消されます。独立的な能力も、周囲と積極的に取り組む能力も、両方を上げることが可能です。あなたのようなタイプは、敢えて脇役に徹し、相手をエスコートするような経験を増やすと、積極型のコミュニケーション能力を高めることができます。「人を喜ばせる」という目的と視点に向き合ってみるのです。</p>
				<p>専門性を高め、実績を増やし、他者へエスコートする経験に飛び込めば、あなたは、その都度、場面に応じて、自分に求められたコミュニケーションパフォーマンスを出すことができるようになります。結果、人間関係において、楽しいと感じることが明らかに増えていくでしょう。</p>
			</div><!-- end .sentence -->
		</div><!-- end .guidance -->
    </div><!-- end .result-index -->				
</template>

<script>


export default {
	name: 'ResultDetailCommunicationOutRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// communicate
		communicateResult:function(){
			return this.$store.getters.communicateResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
